import api, {graphqlQueryBuild} from '../../services/api';

export const LOAD_MOVIES = 'LOAD_MOVIES';

export const loadMovies = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: LOAD_MOVIES,
            payload: {loading: true, movies: undefined},
        });

        let query = graphqlQueryBuild('movies', `id title image duration`);

        let movies_response = await api
            .get('', {
                params: {
                    query,
                },
            })
            .then(res => res)
            .catch(err => err.response);

        dispatch({
            type: LOAD_MOVIES,
            payload: {
                loading: false,
                error: movies_response.status !== 200,
                movies: movies_response.data?.data?.movies || [],
            },
        });

        return movies_response;
    };
};
